const mashupWinTNC = {
  header: "Mashup & Win Terms and Condition",
  body: [
    {
      title: "GENERAL TERMS",
      details: `The MTN Mashup & Win Promotion (the “Promo”) is an MTN promotion which requires the Pulsers to earn points for every mashup done on the Pulse App. These points are redeemable on the last day of the promotion for vouchers from various brands such as KFC, Potbelly Shack, Shoprite and Melcom.
          `,
    },
    {
      title: ``,
      details: `The Promo is exclusive to MTN Pulse APP users only.`,
    },
    {
      title: ``,
      details: ` Pulsers earns 20 points for every GHC 0.50 mashup on the Pulse App`,
    },
    {
      title: ``,
      details: `Pulsers requires a minimum of 2,000 points to redeem a GHC 50.00 voucher.`,
    },
    {
      title: ``,
      details: `Based on available total points, customer can redeem as many vouchers as possible from multiple brands displayed on the app.`,
    },
    {
      title: ``,
      details: `Pulsers are required to redeem points on the app and constantly check the app for update on delivery.`,
    },
    {
      title: `REGISTRATION AND SERVICE`,
      details: `There is no registration required for this Promo.`,
    },
    {
      title: ``,
      details: `Participants must be 18 years and above.`,
    },
    {
      title: ``,
      details: `By activating the service, a customer agrees to be bound by these Terms and Conditions.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to amend or revise the Terms and Conditions at any time without an obligation to notify customers of such amendments. Any amendment or variation of these terms shall be available to customers via the MTN Pulse App. We advise you to periodically review these terms and conditions. `,
    },
    {
      title: ``,
      details: `MTN provides the Promo on an "as is" and "as available" basis, in the hope that you find it useful. MTN does not warrant that the Promo will be free of errors, faults or interruptions and we shall not be liable to you in connection with (but not limited to): `,
    },
    {
      title: ``,
      details: `any cause beyond our reasonable control;`,
    },
    {
      title: ``,
      details: `any failure or delay in the use of or inability to use any component of the service;`,
    },
    {
      title: ``,
      details: `any loss, claim or damage including loss or corruption of data howsoever arising.`,
    },
    {
      title: `SUBSCRIPTION CHARGES`,
      details: `Subscription of service is free.`,
    },
    {
      title: `PROMOTION DURATION`,
      details: `Effective February 15, 2021 to February 28, 2021.`,
    },
    {
      title: `REWARDING SCHEME`,
      details: `At the end of the promo, Prices will be awarded to the Pulsers who redeem their points on the App.`,
    },
    {
      title: ``,
      details: `Redeemed points are not refundable.`,
    },
    {
      title: ``,
      details: `Winners will be given two (2) weeks notification to visit the nearest MTN Service Center to pick up their prices.`,
    },
    {
      title: ``,
      details: `The duration of the promotion may be extended whenever business deems it appropriate`,
    },
    {
      title: ``,
      details: `MTN reserves the right to swap prizes if a particular prize is not applicable in a particular region.`,
    },
    {
      title: `ELIGIBILTY RULES`,
      details: `All prepaid customers on MTN Pulse App.`,
    },
    {
      title: `ABUSE AND DISQUALIFICATION`,
      details: `MTN reserves the right to disqualify a customer when it is proven that the customer used a fraudulent means to participate in the promo.`,
    },
    {
      title: `PERSONAL DATA PROTECTION`,
      details: `By participating in the Promo, the Customer expressly agree that personal data which they supply shall be processed by the MTN for the purpose of executing the Promo and also for the purpose of publicizing the Promotion and MTN. It is hereby specified that MTN guarantees that publicity, entailing the sharing with third parties of personal data supplied as a result of participation in the Promo, (including through television, the press, leaflets and other means and format of communication) shall be made only with respect to the winners of the prizes and will only indicate the given names and surnames of the winners, their images and voices, made for the sole purpose of publicity connected to the promo). Participation in the promo shall be deemed as winners express consent for the use of this data in the manner herein defined.`,
    },
    {
      title: ``,
      details: `Notwithstanding the above, personal date of the winning participants will be retained by MTN in accordance with the law.`,
    },
    {
      title: ``,
      details: ` MTN respects the privacy of Participants of this Promo and accordingly personal data collected during this promo will be treated as private and confidential and in accordance with Data Protection laws of Ghana.`,
    },
    {
      title: `GOVERNING LAW & AMENDMENTS`,
      details: `This Promotion is organized under and governed by the laws and statutes of Ghana.`,
    },
    {
      title: ``,
      details: `These Terms & Conditions are valid during the Promotion Period until amended or suspended by MTN.`,
    },
  ],
};

export default mashupWinTNC;
